import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Language, RxjsComponent } from '@smooved/core';
import { startWith, takeUntil } from 'rxjs/operators';
import { QuestionValidatorType } from '../../enums/question-validator-type.enum';
import { FreeText } from '../../interfaces/meta/questions/free-text';

@Component({
    selector: 'app-question-free-text-component',
    templateUrl: './question-free-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionFreeTextComponent extends RxjsComponent implements OnInit {
    @Input() public question: FreeText;
    @Input() public group: UntypedFormGroup;

    public label: string;

    constructor(private translateService: TranslateService) {
        super();
    }

    public ngOnInit(): void {
        this.translateService.onLangChange
            .pipe(startWith(this.translateService.currentLang), takeUntil(this.destroy$))
            .subscribe(this.setLabel);
    }

    public get formControl(): AbstractControl {
        return this.group?.get('value');
    }

    public get minLengthCounter(): number {
        return this.question?.validators?.find((v) => v.type === QuestionValidatorType.MinLength)?.value;
    }

    private setLabel = (lang: Language): void => {
        this.label =
            `<h6>${this.question.title[lang]}</h6>` +
            (this.question.subLabel ? ` <span class="u-color-muted u-font-size-small">${this.question.subLabel[lang]}</span>` : '');
    };
}
